var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.009 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.044,2.025A6.909,6.909,0,0,0,.645,9.8a.529.529,0,0,0,.583.174A.388.388,0,0,0,1.4,9.507a6.145,6.145,0,0,1,9.968-6.844,6.17,6.17,0,0,1-8.744,8.7.391.391,0,0,0-.583,0,.386.386,0,0,0,0,.58h0a7.026,7.026,0,0,0,9.91,0,6.942,6.942,0,0,0,0-9.86,6.974,6.974,0,0,0-9.91-.058Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7.046A.638.638,0,0,0,0,.6V5.55a.638.638,0,0,0,.7.557.638.638,0,0,0,.7-.557h0V.6A.568.568,0,0,0,.7.046Z",
    transform: "translate(7.7 11.329) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.276.077a.93.93,0,0,0-.744,0A.91.91,0,0,0,0,.9a.874.874,0,0,0,.319.615c.213.2.425.2.638.307a.4.4,0,0,0,.319-.1c.106,0,.213-.1.319-.2A.874.874,0,0,0,1.914.9.874.874,0,0,0,1.595.282C1.488.179,1.382.077,1.276.077Z",
    transform: "translate(7.956 4.683) rotate(180)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokInfo);
export default __webpack_public_path__ + "static/media/hok-info.d99e53ea3ef9c6076162ef84362a0f42.svg";
export { ForwardRef as ReactComponent };